import { render, staticRenderFns } from "./button-action.vue?vue&type=template&id=11dc68d1&"
import script from "./button-action.vue?vue&type=script&lang=js&"
export * from "./button-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11dc68d1')) {
      api.createRecord('11dc68d1', component.options)
    } else {
      api.reload('11dc68d1', component.options)
    }
    module.hot.accept("./button-action.vue?vue&type=template&id=11dc68d1&", function () {
      api.rerender('11dc68d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button-action.vue"
export default component.exports